export const addError = (error, context, extra) => {
  if (!window.DD_RUM) return
  try {
    window.DD_RUM.onReady(() => {
      window.DD_RUM.addError(error, context, extra)
    })
  } catch (e) {}
}

export const addTiming = (name: string, duration?: number) => {
  if (!window.DD_RUM) return
  try {
    window.DD_RUM.onReady(() => {
      window.DD_RUM.addTiming(name, duration)
    })
  } catch (e) {}
}

export const setUser = (user) => {
  if (!window.DD_RUM) return
  try {
    window.DD_RUM.onReady(() => {
      window.DD_RUM.setUser(user)
    })
  } catch (e) {}
}

export const removeUser = () => {
  if (!window.DD_RUM) return
  try {
    window.DD_RUM.removeUser()
  } catch (e) {}
}
